import { apiJson, buildApiUrl } from "./client";
import { toSafeMediaUrl } from "../utils/safeMediaUrl";

/** Map GET /api/Auth/me JSON to client profile (shared by App + Login). */
export function parseAuthMeProfile(data) {
  if (!data || typeof data !== "object") return null;
  const u = data.username ?? data.Username;
  if (typeof u !== "string" || !u.trim()) return null;
  const em = data.email ?? data.Email;
  const uidRaw = data.userId ?? data.UserId;
  const userId =
    typeof uidRaw === "number"
      ? uidRaw
      : typeof uidRaw === "string" && /^\d+$/.test(uidRaw.trim())
        ? parseInt(uidRaw.trim(), 10)
        : null;
  const rawUrl = data.profileImageUrl ?? data.ProfileImageUrl;
  const profileImageUrl = toSafeMediaUrl(
    typeof rawUrl === "string" ? rawUrl : null
  );
  return {
    username: u.trim(),
    email: typeof em === "string" ? em : "",
    userId: Number.isFinite(userId) ? userId : null,
    profileImageUrl
  };
}

export function sendRegistrationOtp(email) {
  return apiJson("/api/Auth/send-registration-otp", {
    method: "POST",
    body: { email },
    auth: false
  });
}

export function verifyRegistrationOtp(dto) {
  return apiJson("/api/Auth/verify-registration-otp", {
    method: "POST",
    body: dto,
    auth: false
  });
}

export function checkUsernameAvailability(username) {
  return apiJson("/api/Auth/username-availability", {
    method: "GET",
    query: { username },
    auth: false
  });
}

export function register(dto) {
  return apiJson("/api/Auth/register", {
    method: "POST",
    body: dto,
    auth: false,
    fastAuth: true
  });
}

export function login(dto) {
  return apiJson("/api/Auth/login", {
    method: "POST",
    body: dto,
    auth: false,
    fastAuth: true
  });
}

export function sendForgotPasswordOtp(usernameOrEmail) {
  return apiJson("/api/Auth/forgot-password/send-otp", {
    method: "POST",
    body: { usernameOrEmail },
    auth: false
  });
}

export function verifyForgotPasswordOtp(dto) {
  return apiJson("/api/Auth/forgot-password/verify-otp", {
    method: "POST",
    body: dto,
    auth: false
  });
}

export function resetForgotPassword(dto) {
  return apiJson("/api/Auth/forgot-password/reset", {
    method: "POST",
    body: dto,
    auth: false
  });
}

/** Cookie session: returns 200 + profile when HttpOnly JWT is valid. */
export function getAuthMe() {
  return apiJson("/api/Auth/me", {
    method: "GET",
    auth: true,
    expireSessionOn401: true,
    fastAuth: true
  });
}

/** Clears HttpOnly auth cookie on the server (no valid session required). */
export function logoutAuth() {
  return apiJson("/api/Auth/logout", { method: "POST", auth: false });
}

/**
 * Multipart upload; replaces existing photo. Cookie auth only.
 * @param {File} file
 * @returns {Promise<import("./client").ApiJsonResult>}
 */
export async function uploadProfilePhoto(file) {
  const form = new FormData();
  form.append("file", file);
  const response = await fetch(buildApiUrl("/api/Auth/profile-photo"), {
    method: "POST",
    credentials: "include",
    headers: { "X-WillPlay-Request": "1" },
    body: form
  });
  const text = await response.text();
  let data = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = text;
    }
  }
  return { response, data };
}

/** Remove profile photo. */
export function deleteProfilePhoto() {
  return apiJson("/api/Auth/profile-photo", { method: "DELETE", auth: true });
}
